import { CampaignType } from "@vviinn/user-managment-client-ts";
import { BoostingCampaignScoreContributionStrategyEnum } from "@vviinn/user-managment-client-ts/dist/models/BoostingCampaign";

export const boostingNumberProps = { step: 0.01, max: 1, min: 0 };

export const boostingLimitNumberProps = { step: 1, min: 1 };

// Only these service campaign types can ever be linked to a boosting campaign —
// eligibility doesn't depend on whether the campaign is active or inactive. Same rule
// that already gates the "Linked Boosting" widget on a service campaign's own page
// (src/routes/campaign/service/details.tsx) — kept as one shared source of truth.
export const BOOSTING_ELIGIBLE_CAMPAIGN_TYPES: CampaignType[] = [
  "TEXT_SEARCH",
  "VPR",
];

export const EMPTY_PREFERRED_VALUE = { weight: 1, rawValue: "" };
export const PREFERRED_VALUE_REQUIRED_KEYS: (keyof typeof EMPTY_PREFERRED_VALUE)[] =
  ["rawValue"];

export const STRATEGY_OPTIONS: {
  value: BoostingCampaignScoreContributionStrategyEnum;
  title: string;
}[] = [
  { value: "PREFER_HIGHER_RANK", title: "Prefer higher / matching values" },
  { value: "PREFER_LOWER_RANK", title: "Prefer lower / non-matching values" },
];

export const STRATEGY_LABEL = Object.fromEntries(
  STRATEGY_OPTIONS.map((o) => [o.value, o.title]),
) as Record<BoostingCampaignScoreContributionStrategyEnum, string>;
